import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import axios from 'axios';

const WidgetMovimentosMensal = () => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 240,
      },
      // Definindo as cores: verde para Entrada e vermelha para Saída
      colors: ['#00E396', '#FF4560'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Quantidade',
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: (val) => val,
        },
      },
      legend: {
        position: 'top',
      },
    }
  });

  useEffect(() => {
    axios.get('/api/estoque/movimentos-mensal/')
      .then(response => {
        const data = response.data;
        // Mapeamento dos meses para português
        const monthMapping = {
          "Jan": "Jan",  // ou "Janeiro"
          "Feb": "Fev",  // ou "Fevereiro"
          "Mar": "Mar",  // ou "Março"
          "Apr": "Abr",  // ou "Abril"
          "May": "Mai",  // ou "Maio"
          "Jun": "Jun",  // ou "Junho"
          "Jul": "Jul",  // ou "Julho"
          "Aug": "Ago",  // ou "Agosto"
          "Sep": "Set",  // ou "Setembro"
          "Oct": "Out",  // ou "Outubro"
          "Nov": "Nov",  // ou "Novembro"
          "Dec": "Dez",  // ou "Dezembro"
        };
        // Converte os rótulos para português
        const labelsPt = data.labels.map(label => monthMapping[label] || label);
        setChartData({
          series: [
            {
              name: 'Entrada',
              data: data.entradas,
            },
            {
              name: 'Saída',
              data: data.saidas,
            }
          ],
          options: {
            ...chartData.options,
            xaxis: {
              categories: labelsPt,
            }
          }
        });
      })
      .catch(error => {
        console.error("Erro ao buscar dados mensais:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Resumo Mensal</h3>
      </div>
      <div className="card-body">
        <Chart options={chartData.options} series={chartData.series} type="bar" height={240} />
      </div>
    </div>
  );
};

export default WidgetMovimentosMensal;